import { Box } from '@mui/system';
import "../../common/common_styles.css";
import checkboxClasses from "../CriteriaSubmission/assesmentForm/questionTypes/questionTypes.module.css";
import UploadContent from "../UI/UploadContent/uploadContent";
import { useDispatch, useSelector } from "react-redux";
import { setRubricData, selectRubricData } from '../../slices/gradingForm';
import { useAppUsageLogger } from "../../slices/authApi";
import Modal from '../../common/Modal';
import classes from './RubricCriteria.module.css'
import { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import ErrorModal from "../UI/error_modal/error_modal";
import util from '../../styles/utilities.module.css';

const RubricCriteria = ( ) => {
    const rubricData = useSelector(selectRubricData);
    const dispatch = useDispatch();
    const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
    const [addedCategoryName,setAddedCategoryName] = useState('');
    const [addedCategoryDescription, setAddedCategoryDescription] = useState('');
    const logAppUse = useAppUsageLogger();
    const [categoryNameError, setCategoryNameError] = useState(false);
    const [isUserCreated, setIsUserCreated] = useState(false);
    const [categoryToRemoveId, setCategoryToRemoveid] = useState(0);
    const [showLimitReachedModal, setShowLimitReachedModal] = useState(false);
    const [fileUploadMessage, setFileUploadMessage] = useState("");
    const [showErrorModal, setShowErrorModal] = useState(false);

    const location = useLocation();

    // Function to check and set the file upload message based on metadata
    const checkFileUploadMessage = (metadata) => {
        let message = "";
        metadata.forEach((file) => {
          // Check if OCR confidence is below a threshold (e.g., 80)
          if (file.ocr_confidence < 80) {
            message += `${file.name} - difficult to read and may need to be rescanned.\n\n`;
          }
        });
        setFileUploadMessage(message);
      };
    
      // Use effect to check and set the message when metadata changes
      useEffect(() => {
        const fileMetadata = location.state?.fileMetadata || [];
        if (fileMetadata.length > 0) {
            checkFileUploadMessage(fileMetadata);
        }
    }, [location.state?.fileMetadata]);
    
      // Directly use fileUploadMessage state to decide modal visibility
    useEffect(() => {
        if (fileUploadMessage) {
          setShowErrorModal(true);
        }
      }, [fileUploadMessage]);



    const handleCheckboxChange = (e) => {
        const selectedCount = rubricData.issue_categories.filter((cat)=>cat.selected===true).length;
        const { checked, value } = e.target;


    if(selectedCount<5 || (selectedCount === 5 && !checked) ){
        const numericId = parseInt(value, 10); // Ensure id is treated as an integer
        const storedCategories = JSON.parse(localStorage.getItem('userAddedCategories')); 

        const updatedLocalCategories = storedCategories.map((issue) =>
            issue.id === numericId ? { ...issue, selected: checked } : issue
        );

     
        localStorage.setItem('userAddedCategories', JSON.stringify(updatedLocalCategories));

        const updatedIssues = rubricData.issue_categories.map((issue) =>
            issue.id === numericId ? { ...issue, selected: checked } : issue
        );
        dispatch(setRubricData({ issue_categories: updatedIssues }));
    }else {
        setShowLimitReachedModal(true);
        logAppUse("rubric", "max_category_error");
    }
    };

    const handleGradingScaleChange = (e) => {
        const newGradingScale = e.target.value;
        dispatch(setRubricData({ grading_scale: newGradingScale }));
    };

    const handleAddCategory = ()=>{
        logAppUse("rubric","category_pop_up");
        setShowAddCategoryModal(true);
        setIsUserCreated(false);
        setCategoryToRemoveid(0);
    }

    const cancelHandler = ()=>{
        logAppUse("category_pop_up", "rubric");
        setAddedCategoryName('');
        setAddedCategoryDescription('');
        setShowAddCategoryModal(false);
        setIsUserCreated(false);
        setCategoryNameError(false);
        setCategoryToRemoveid(0);
    }


    const removeCategoryHandler = ()=>{
        
        const storedCategories = JSON.parse(localStorage.getItem('userAddedCategories'));     
        const updatedLocalCategories = storedCategories.filter((cat)=>cat.id !== categoryToRemoveId);
        localStorage.setItem('userAddedCategories', JSON.stringify(updatedLocalCategories));

        const updatedIssues = rubricData.issue_categories.filter((cat)=>cat.id !== categoryToRemoveId);
        dispatch(setRubricData({ issue_categories: updatedIssues }));

        setShowAddCategoryModal(false);
        setAddedCategoryDescription('');
        setAddedCategoryName('');
        setCategoryToRemoveid(0);
    }


    const saveHandler = ()=>{

        if(addedCategoryName === ''){
                setCategoryNameError(true)
        }
        else {

            const selectedCount = rubricData.issue_categories.filter((cat)=>cat.selected===true).length;

            if(selectedCount <5) {

            const maxIdObject = rubricData.issue_categories.reduce((maxObj, currentObj) => {
                return currentObj.id > maxObj.id ? currentObj : maxObj;
              }, { id: -Infinity });

        const newId = maxIdObject.id+1;
        
        const storedCategories = JSON.parse(localStorage.getItem('userAddedCategories'));     
       

        const newCategory = {
            description: addedCategoryDescription,
            id: newId,
            name: addedCategoryName,
            selected:true,
            userCreated: true
        }
        storedCategories.push(newCategory);
        localStorage.setItem('userAddedCategories', JSON.stringify(storedCategories));
        const updatedIssues = [...rubricData.issue_categories , newCategory];

        dispatch(setRubricData({ issue_categories: updatedIssues }));

        logAppUse("category_pop_up", "rubric");
        setAddedCategoryName('');
        setAddedCategoryDescription('');
        setShowAddCategoryModal(false);
        setCategoryToRemoveid(0);
    } else {
        
        logAppUse("rubric", "max_category_error");
        setShowLimitReachedModal(true);
    }

    }
    }

    const handleCategoryDescriptionChange = (e)=>{
        setAddedCategoryDescription(e.target.value);
    }

    const handleCategoryNameChange = (e)=>{
        setCategoryNameError(false)
        setAddedCategoryName(e.target.value);
    }


    const handleNewAddedCategoryClick = (cat)=>{
  
            if(cat.userCreated){
                setShowAddCategoryModal(true);
                setIsUserCreated(true);
                setAddedCategoryName(cat.name);
                setAddedCategoryDescription(cat.description);
                setCategoryToRemoveid(cat.id)
            }
    }

    const closeLimitModalHandler = ()=>{
        logAppUse("category_pop_up", "rubric");
        setAddedCategoryName('');
        setAddedCategoryDescription('');
        setShowLimitReachedModal(false);
        setShowAddCategoryModal(false);
        setIsUserCreated(false);
        setCategoryNameError(false);
        setCategoryToRemoveid(0);
    }



    // useEffect(()=>{
    //     const storedCategories = JSON.parse(localStorage.getItem('userAddedCategories'));
    //         if(storedCategories)
    //         {   
    //             console.log("rubricData.issue_categories before filter", rubricData.issue_categories);
    //             const idsToRemove = storedCategories.map(obj => obj.id);
    //             const result = rubricData.issue_categories.filter((cat)=>!idsToRemove.includes(cat.id));
    //             const catToShow = [...result, ...storedCategories];
    //             const updatedIssues = catToShow;
    //             console.log("rubricData.issue_categories to be set", updatedIssues);
    //             dispatch(setRubricData({ issue_categories: updatedIssues }));
    //             console.log("rubricData.issue_categories after filter", rubricData.issue_categories);

    //         }else {
    //             localStorage.setItem('userAddedCategories', JSON.stringify([]));
    //         }

    // },[dispatch, rubricData.issue_categories])

    useEffect(() => {
        const storedCategories = JSON.parse(localStorage.getItem('userAddedCategories')) || [];
        const idsToRemove = storedCategories.map(obj => obj.id);
        const filteredIssues = rubricData.issue_categories.filter(cat => !idsToRemove.includes(cat.id));
        const updatedIssues = [...filteredIssues, ...storedCategories];
    
        // Only update if necessary
        if (JSON.stringify(rubricData.issue_categories) !== JSON.stringify(updatedIssues)) {
            dispatch(setRubricData({ issue_categories: updatedIssues }));
        }
    }, [dispatch, rubricData.issue_categories]);
    

    return (
        <div>
            <UploadContent 
              textLabel="Copy/paste or upload your rubric (optional):"
              textPlaceholder="Enter your rubric or provide detailed specifications 
              for how you'd like the student's work to be assessed. Be as specific as possible.&#13;&#10;---&#13;&#10;Include 
              your different assessment criteria (e.g. writing mechanics, organization &
              clarity, etc). For each criterion, give a grading scale and 
              provide an explicit description of the qualities or elements of student 
              work you're looking for at each level of the scale.&#13;&#10;---&#13;&#10;Consider the following: What specific characteristics 
              should be present in the student's work to achieve the highest points for this 
              criterion? What distinguishes exemplary work from average or unsatisfactory work? Are there common pitfalls or mistakes that 
              should result in a lower score for this criterion? Is this take-home or in-class (and thus needs more leniency)?"
              nameInStore={"rubric"}
              selectStoreData={selectRubricData}
              setStoreData={setRubricData}

            />
            <div className='input-container'>
                <label className={classes.formLabel}>Specify your overall grading scale:</label>
                <textarea
                    style={{
                     resize: "none",
                    }}
                    className='textArea'
                    rows={2}
                    name="grading_scale"
                    placeholder='For example, you could say "Letter Grade Scale (A through F)", "Numerical Scale (1-100)", "Competency-based Scale (exceed expectations, meet expectations, approaching expectations, not meeting expectations)"'
                    value={rubricData.grading_scale || ''}
                    onChange={handleGradingScaleChange}
                    required={true}
                />
            </div>
            {true ?
            <>
                <div className='input-container'>
                    <label className={classes.formLabel}>Include additional, specific feedback that won't affect the assigned grade? (optional): </label>
                </div>
                
                <Box
                    sx={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "center",
                    flexDirection: "row",
                    flexWrap: "wrap"  // Enables wrapping of items
                    }}
                >
                    {rubricData.issue_categories.map((cat) => (
                    <div key={cat.id} style={{width: "250px"}}>
                        <div className={checkboxClasses.individualCheckbox} >
                            <label className={checkboxClasses.container}  >
                                <input
                                    name={cat.name}
                                    value={cat.id}
                                    type="checkbox"
                                    checked={cat.selected}
                                    onChange={handleCheckboxChange} 
                                    />
                                <span className={checkboxClasses.checkmark}></span>
                            </label>
                            <span onClick={()=>handleNewAddedCategoryClick(cat)} className={cat.userCreated ? classes.newAddedCategory : ""}>{cat.name}</span>
                        </div>
                    </div>
                    ))}
                </Box>
                <br />
                <br />
                
                {false ? <>
                    <div className='addCategoryContainer'>
                        <span  onClick={handleAddCategory} className="criteriaSubmission_uploadButton__yDstz" type="button">Add Category</span>
                    </div>   
                        
                    {showAddCategoryModal ? <Modal showButtons={true} removeCategoryHandler = {removeCategoryHandler} removeCategory={isUserCreated? true:false} saveHandler={saveHandler} cancelHandler={cancelHandler}>
                        <div className={classes.addCategoryContainer}>                     
                            <div className= {classes.addCategoryRowContainer}>
                                <p>Category Name:</p>
                                <input value={addedCategoryName} style={categoryNameError ? {borderColor:"red"}:{}} onChange={handleCategoryNameChange}/>
                            </div>
                            <div className={classes.addCategoryRowContainer}>   
                            <p>Description:</p>
                                <input value={addedCategoryDescription} onChange={handleCategoryDescriptionChange}/>
                            </div>
                            <div className={classes.modalButtonContainer}>
                        

                            </div>
                        </div>


                    </Modal>:<></>}

                    {showLimitReachedModal ? <Modal>
                        <div className={classes.infoModalWrapper}>
                            <p>Maximum category limit reached.</p>
                            <p>Please deselect a category before <br /> adding a new one.</p>
                            <div className={classes.closeBtnContainer}>
                            <button onClick={closeLimitModalHandler} className={util.btn}>
                                Close
                            </button>
                            </div>
                        </div>
                    </Modal>:<></>}
                </>:<></>}
            </>:<></>}
          <br />
          <ErrorModal
                    isOpen={showErrorModal}
                    onClose={() => setShowErrorModal(false)}
                    titleText={"Potential issue with upload"}
                    bodyText={fileUploadMessage}
              />
          </div>
    );
};

export default RubricCriteria;
